import React from "react"
import { Control } from "react-hook-form"
import BadgeShapeFields from "./BadgeShapeFields"
import { BadgeElementFormValues } from "../BadgeSidePanelForm"

type Props = {
  control: Control<BadgeElementFormValues>
}

const BadgeOvalFields = ({ control }: Props) => (
  <BadgeShapeFields control={control} shapeType="oval" />
)

export default BadgeOvalFields
